module.exports = __webpack_public_path__ + "img/DrySystem-Assembly.af71bc1d.jpg";